export default __webpack_public_path__ + "static/media/5.c5f9ec2e.png";